export default "__VITE_ASSET__OEnYfcMIk4zZrHiizmY4yQ__";